import { initialState } from "./state"
export default {
  updateCurrentStep: (state, payload) => (state.currentStep = payload),
  updateFlow: (state, payload) => (state.flow = { ...state.flow, ...payload }),
  updateLoading: (state, payload) => (state.loading = {...state.loading, ...payload}),
  updateIsCopying: (state, payload) => (state.isCopying = payload),
  updateIsEditing: (state, payload) => (state.isEditing = payload),
  updateIsSelectAllRoles: (state, payload) => (state.isSelectAllRoles = payload),
  updateUuid: (state, payload) => (state.uuid = payload),
  fillFlow: (state, payload) => (state.flow = payload),
  resetFlow: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}